import React, { useEffect, useState } from "react";
import { Heart, MessageCircle, Share2, Facebook } from "lucide-react";
import { getSocialPosts } from "../lib/api";

export default function SocialFeed() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    getSocialPosts().then(setPosts).catch(() => {});
  }, []);

  return (
    <div className="rounded-lg border border-[var(--paper-border)] bg-white" data-testid="social-feed">
      <div className="flex items-center justify-between rounded-t-lg bg-[#1877F2] px-4 py-3 text-white">
        <div className="flex items-center gap-2">
          <Facebook size={20} />
          <div>
            <p className="font-ui text-sm font-bold leading-none">News-Leader on Facebook</p>
            <p className="font-ui text-[11px] text-white/80">@fbnewsleader · Follow</p>
          </div>
        </div>
        <a
          href="https://www.facebook.com/"
          target="_blank"
          rel="noreferrer"
          data-testid="follow-facebook"
          className="font-ui rounded bg-white/20 px-3 py-1 text-xs font-semibold hover:bg-white/30"
        >
          Follow
        </a>
      </div>
      <div className="no-scrollbar max-h-[560px] divide-y divide-[var(--paper-border)] overflow-y-auto">
        {posts.map((p) => (
          <div key={p.id} className="p-4" data-testid={`social-post-${p.id}`}>
            <div className="flex items-start gap-3">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--navy)] text-xs font-bold text-white">
                {p.author.split(" ").map((w) => w[0]).join("").slice(0, 2)}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="font-ui truncate text-sm font-bold text-[var(--ink)]">{p.author}</p>
                  {p.sponsored && (
                    <span className="eyebrow shrink-0 rounded-sm bg-amber-100 px-1.5 py-0.5 text-[9px] text-amber-700">Co-Sponsored</span>
                  )}
                </div>
                <p className="font-ui text-[11px] text-slate-500">{p.handle} · {p.time}</p>
              </div>
            </div>
            <p className="font-serif-body mt-2 text-sm leading-relaxed text-slate-700">{p.text}</p>
            {p.image && (
              <div className="img-zoom mt-3 overflow-hidden rounded-md">
                <img src={p.image} alt="" className="h-44 w-full object-cover" />
              </div>
            )}
            <div className="font-ui mt-3 flex items-center gap-5 text-xs text-slate-500">
              <span className="flex items-center gap-1 hover:text-[#1877F2]"><Heart size={14} /> {p.likes}</span>
              <span className="flex items-center gap-1 hover:text-[#1877F2]"><MessageCircle size={14} /> {p.comments}</span>
              <span className="flex items-center gap-1 hover:text-[#1877F2]"><Share2 size={14} /> {p.shares}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
